
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();
  
  return (
    <footer className="bg-noa-rich-black text-noa-antiflash-white py-12 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="mb-8 md:mb-0">
            <img 
              src="/lovable-uploads/662a87e6-f1ba-4f67-9522-3f96b2535b33.png" 
              alt="Noa Partners Logo" 
              className="h-10 mb-4"
            />
            <p className="max-w-md text-noa-antiflash-white/80 text-sm">
              Noa, your forever partner
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-space-grotesk font-bold text-lg mb-4">{t('navigation')}</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-noa-antiflash-white/80 hover:text-white transition-colors">{t('home')}</Link></li>
                <li><Link to="/why-sell-to-noa" className="text-noa-antiflash-white/80 hover:text-white transition-colors">{t('partner_with_noa')}</Link></li>
                <li><Link to="/about" className="text-noa-antiflash-white/80 hover:text-white transition-colors">{t('about_noa')}</Link></li>
                <li><Link to="/contact" className="text-noa-antiflash-white/80 hover:text-white transition-colors">{t('contact_us')}</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-space-grotesk font-bold text-lg mb-4">{t('connect')}</h4>
              <ul className="space-y-2">
                <li><a href="mailto:info@noapartners.com" className="text-noa-antiflash-white/80 hover:text-white transition-colors">Email</a></li>
              </ul>
            </div>
            
            <div className="col-span-2 md:col-span-1">
              <h4 className="font-space-grotesk font-bold text-lg mb-4">{t('address')}</h4>
              <address className="not-italic text-noa-antiflash-white/80">
                Guadalajara 21, Roma Nte.,<br />
                Cuauhtémoc, 06700 Ciudad de México,<br />
                CDMX, Mexico<br />
                <a href="mailto:info@noapartners.com" className="hover:text-white transition-colors text-noa-antiflash-white/80">
                  info@noapartners.com
                </a>
              </address>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-noa-antiflash-white/10 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-noa-antiflash-white/60">
            &copy; {currentYear} Noa Partners. {t('rights_reserved')}
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6">
            <Link to="/privacy-policy" className="text-sm text-noa-antiflash-white/60 hover:text-white transition-colors">{t('privacy_policy')}</Link>
            <Link to="/terms" className="text-sm text-noa-antiflash-white/60 hover:text-white transition-colors">{t('terms_of_service')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
